import type { ActivityModule } from '../../core/activity';
import { mountFractionsCreate } from './ui';
import levelsData from './levels.json';
import './style.css';

export const fractionsCreate: ActivityModule = {
  id: 'fractions_create',
  title: 'Crie a fração',
  description: 'Pinte a quantidade certa de pedaços pra montar a fração pedida.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/fractions_create/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountFractionsCreate,
};
